import { call, put, takeLatest } from "@redux-saga/core/effects";
import { FaqApi } from "./FaqApi";
import { FaqConstant } from "./FaqConstant";
import { FaqParser } from "./FaqParser";

function* getFaqCategories({payload}) {
  try {
    yield put({ type: FaqConstant.FAQ_CATEGORIES_REQUEST });
    const res = yield call(FaqApi.getFaqCategories, payload);
    const data = FaqParser.getCategoriesParser(res);
    yield put({
      type: FaqConstant.FAQ_CATEGORIES_RESPONSE,
      payload: data,
    });
  } catch (e) {
 
    yield put({
      type: FaqConstant.FAQ_CATEGORIES_RESPONSE,
      payload: [],
    });
  }
}



function* getFaqParentCategories( {payload} ) {
  try {
    yield put({ type: FaqConstant.FAQ_CATEGORIES_PARENT_REQUEST });
    const res = yield call(FaqApi.getFaqParentCategories, payload);
    const data = FaqParser.getCategoriesParentParser(res);
    yield put({
      type: FaqConstant.FAQ_CATEGORIES_PARENT_RESPONSE,
      payload: data,
    });
  } catch (e) {
    yield put({
      type: FaqConstant.FAQ_CATEGORIES_PARENT_RESPONSE,
      payload: [],
    });
  }
}


function* postFaqCategories(payload) {
  try {
    yield put({
      type: FaqConstant.POST_FAQ_CATEGORIES_REQUEST,
    });
    const res = yield call(FaqApi.postFaqCategoriesApi, payload.payload);

    yield put({
      type: FaqConstant.POST_FAQ_CATEGORIES_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: FaqConstant.POST_FAQ_CATEGORIES_RESPONSE,
      payload: [],
    });
  }
}

function* updateFaqCategories(payload) {
  try {
    yield put({
      type: FaqConstant.UPDATE_FAQ_CATEGORIES_REQUEST,
    });
    const res = yield call(FaqApi.updateFaqCategoriesApi, payload.payload);

    yield put({
      type: FaqConstant.UPDATE_FAQ_CATEGORIES_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: FaqConstant.UPDATE_FAQ_CATEGORIES_RESPONSE,
      payload: [],
    });
  }
}

function* FaqCategoriesEnableDisable(payload) {
  try {
    yield put({
      type: FaqConstant.FAQ_CATEGORIES_STATUS_REQUEST,
    });
    const res = yield call(FaqApi.FaqCategoriesStatusApi, payload.payload);

    yield put({
      type: FaqConstant.FAQ_CATEGORIES_STATUS_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: FaqConstant.FAQ_CATEGORIES_STATUS_RESPONSE,
      payload: [],
    });
  }
}

function* FaqCategoriesDelete(payload) {
  try {
    yield put({
      type: FaqConstant.FAQ_CATEGORIES_DELETE_REQUEST,
    });
    const res = yield call(FaqApi.FaqCategoriesDeleteApi, payload.payload);

    yield put({
      type: FaqConstant.FAQ_CATEGORIES_DELETE_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: FaqConstant.FAQ_CATEGORIES_DELETE_RESPONSE,
      payload: [],
    });
  }
}






function* deleteFaq(payload ) {
  try {
    yield put({
      type: FaqConstant.FAQ_DELETE_REQUEST,
    });
    const res = yield call(FaqApi.deleteFaqApi, payload.payload);
    yield put({
      type: FaqConstant.FAQ_DELETE_RESPONSE,
      payload: res,
    });
  } catch (e) {
    yield put({
      type: FaqConstant.FAQ_DELETE_RESPONSE,
      payload: {},
    });
  }
}





function* postFaq({ payload }) {
  try {
    yield put({ type: FaqConstant.FAQ_POST_REQUEST });
    const res = yield call(FaqApi.postFaqApi, payload);

    yield put({
      type: FaqConstant.FAQ_POST_RESPONSE,
      payload: res,
    });
  } catch (error) {
    console.log("Error", error);
    yield put({
      type: FaqConstant.FAQ_POST_RESPONSE,
      payload: [],
    });
  }
}



function* FaqUpdate(payload) {
  try {
    yield put({
      type: FaqConstant.FAQ_UPDATE_REQUEST,
    });
    const res = yield call(FaqApi.UpdateFaqApi, payload.payload);

    yield put({
      type: FaqConstant.FAQ_UPDATE_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: FaqConstant.FAQ_UPDATE_RESPONSE,
      payload: [],
    });
  }
}

//keyword store start here
function* getFaqKeyword({ payload }) {
  try {
    yield put({ type: FaqConstant.GET_FAQ_KEYWORD_REQUEST });
    const res = yield call(FaqApi.getFaqKeywordApi, payload);
    const result = FaqParser.getFaqKeywordParser(res);

    yield put({
      type: FaqConstant.GET_FAQ_KEYWORD_RESPONSE,
      payload: result,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: FaqConstant.GET_FAQ_KEYWORD_RESPONSE,
      payload: [],
    });
  }
}

function* getFaq({ payload }) {
  try {
    const { id, status, category_id, subcategory_id,content_type ,search} = payload;
    
    yield put({ type: FaqConstant.FAQ_REQUEST });

    const res = yield call(FaqApi.getFaq, { id, status, category_id, subcategory_id,content_type,search });
    const result = FaqParser.getFaqParser(res);

    yield put({
      type: FaqConstant.FAQ_RESPONSE,
      payload: result,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: FaqConstant.FAQ_RESPONSE,
      payload: [],
    });
  }
}

function* postFaqKeyword(payload) {
  try {
    yield put({
      type: FaqConstant.POST_FAQ_KEYWORD_REQUEST,
    });
    const res = yield call(FaqApi.postFaqKeywordApi, payload.payload);

    yield put({
      type: FaqConstant.POST_FAQ_KEYWORD_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: FaqConstant.POST_FAQ_KEYWORD_RESPONSE,
      payload: [],
    });
  }
}
function* updateFaqKeyword(payload) {
  try {
    yield put({
      type: FaqConstant.POST_FAQ_KEYWORD_REQUEST,
    });
    const res = yield call(FaqApi.updateFaqKeywordApi, payload.payload);

    yield put({
      type: FaqConstant.POST_FAQ_KEYWORD_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: FaqConstant.POST_FAQ_KEYWORD_RESPONSE,
      payload: [],
    });
  }
}

function* deleteFaqKeyword(payload) {

  try {
    yield put({
      type: FaqConstant.DELETE_FAQ_KEYWORD_REQUEST,
    });
    const res = yield call(FaqApi.deleteFaqKeywordApi, payload.payload);
    yield put({
      type: FaqConstant.DELETE_FAQ_KEYWORD_RESPONSE,
      payload: res,
    });
  } catch (e) {
    yield put({
      type: FaqConstant.DELETE_FAQ_KEYWORD_RESPONSE,
      payload: {},
    });
  }
}

export function* registergetFaqSaga() {
  yield takeLatest(FaqConstant.FAQ_CATEGORIES_SAGA, getFaqCategories);
  yield takeLatest(FaqConstant.FAQ_CATEGORIES_PARENT_SAGA, getFaqParentCategories);
  yield takeLatest(FaqConstant.FAQ_SAGA, getFaq);
  yield takeLatest(FaqConstant.FAQ_POST_SAGA, postFaq);
  yield takeLatest(FaqConstant.FAQ_DELETE_SAGA, deleteFaq);
  yield takeLatest(FaqConstant.POST_FAQ_CATEGORIES_SAGA, postFaqCategories);
  yield takeLatest(FaqConstant.FAQ_CATEGORIES_STATUS_SAGA,FaqCategoriesEnableDisable);
  yield takeLatest(FaqConstant.UPDATE_FAQ_CATEGORIES_SAGA, updateFaqCategories);
  yield takeLatest(FaqConstant.FAQ_CATEGORIES_DELETE_SAGA, FaqCategoriesDelete);
  yield takeLatest(FaqConstant.FAQ_UPDATE_SAGA, FaqUpdate);

  //faq-keywords
  yield takeLatest(FaqConstant.GET_FAQ_KEYWORD_SAGA, getFaqKeyword);
  yield takeLatest(FaqConstant.POST_FAQ_KEYWORD_SAGA, postFaqKeyword);
  yield takeLatest(FaqConstant.UPDATE_FAQ_KEYWORD_SAGA, updateFaqKeyword);
  yield takeLatest(FaqConstant.DELETE_FAQ_KEYWORD_SAGA, deleteFaqKeyword);
}
